import { subDays } from 'date-fns'
import mapValues from 'lodash-es/mapValues'

import { EMPTY_LIST } from '../../../../constants/common'
import { REQUEST_STATUS } from '../../../../constants/request'
import {
  BIRDVIEW_CHART_AGING_BUCKETS,
  BIRDVIEW_CHART_REQUEST_STATUS_SEGMENTS,
  BIRDVIEW_KPI_SPARK_DAYS,
  BirdviewRequestChart,
} from '../../DashboardBirdview.constants.charts'
import {
  toBirdviewChartSection,
  toBirdviewSeriesSection,
} from '../../DashboardBirdview.utils.charts'

function getBirdviewRequestStatusSegments() {
  return BIRDVIEW_CHART_REQUEST_STATUS_SEGMENTS.map(({ color, status }) => ({
    apiKey: status,
    color,
    labelKey: REQUEST_STATUS[status].text,
  }))
}

function toBirdviewSegmentChartItems(values, segments) {
  return segments.map(segment => ({
    ...segment,
    id: segment.apiKey,
    value: values[segment.apiKey],
  }))
}

function toBirdviewStackedChartItems(items) {
  return items.map(item => ({ ...item, value: item.open + item.overdue }))
}

// A request with several managers counts for each of them (OD-16), so the open
// total comes as its own field instead of the sum of the bars.
function toBirdviewManagerSection({ items, openTotal }) {
  return {
    ...toBirdviewChartSection(toBirdviewStackedChartItems(items)),
    total: openTotal,
  }
}

// The buckets are fixed columns, so a zero one stays on the axis; only a
// portfolio without open requests leaves the card empty.
function toBirdviewAgingSection({ buckets, openTotal }) {
  return {
    items:
      openTotal > 0
        ? toBirdviewSegmentChartItems(buckets, BIRDVIEW_CHART_AGING_BUCKETS)
        : EMPTY_LIST,
    total: openTotal,
  }
}

function toBirdviewKpiSparkPoints(spark, now) {
  const lastIndex = spark.length - 1

  return spark.map((value, index) => ({
    date: subDays(
      now,
      lastIndex > 0
        ? Math.round(
            ((lastIndex - index) * BIRDVIEW_KPI_SPARK_DAYS) / lastIndex
          )
        : 0
    ).toISOString(),
    value,
  }))
}

export function toBirdviewRequestsCharts(charts) {
  return {
    [BirdviewRequestChart.Aging]: toBirdviewAgingSection(
      charts[BirdviewRequestChart.Aging]
    ),
    [BirdviewRequestChart.ByBuilding]: toBirdviewChartSection(
      charts[BirdviewRequestChart.ByBuilding]
    ),
    [BirdviewRequestChart.ByManager]: toBirdviewManagerSection(
      charts[BirdviewRequestChart.ByManager]
    ),
    [BirdviewRequestChart.ByStatus]: toBirdviewChartSection(
      toBirdviewSegmentChartItems(
        charts[BirdviewRequestChart.ByStatus],
        getBirdviewRequestStatusSegments()
      )
    ),
    [BirdviewRequestChart.ByType]: toBirdviewChartSection(
      charts[BirdviewRequestChart.ByType]
    ),
    [BirdviewRequestChart.OpenedVsClosed]: toBirdviewSeriesSection(
      charts[BirdviewRequestChart.OpenedVsClosed]
    ),
  }
}

export function toBirdviewKpis(kpis) {
  const now = new Date()

  return mapValues(kpis, kpi => ({
    ...kpi,
    points: toBirdviewKpiSparkPoints(kpi.spark, now),
  }))
}
